import React from "react";

import { ICustomer } from "../../interfaces/customer";
import { useUser } from "../../store/UserStore";
import moment from "moment";
import { updateBooking } from "../../services/booking.service";
import { GetErrorMessage } from "../../functions/error";
import { useError } from "../../store/ErrorModal";
import {
  ButtonContainer,
  CancelButton,
  CaseIdText,
  ConfirmButton,
  Container,
  DescriptionContainer,
  HeaderText,
  ImageProfile,
  ModalImplement,
  PetNameContainer,
  PetSpan,
  ProfileContainer,
  ProfileName,
} from "./ModalCustomer.style";

const ModalCustomer = (props: {
  customer: ICustomer;
  ToggleClose: () => void;
  isOpen: boolean;
  refashData: () => void;
}) => {
  const { userData } = useUser();
  const { onError } = useError();
  const handleDoctorSelectSubmit = async (booking: ICustomer) => {
    const timeRange = booking.product.timeRange || 1440;
    const dayRange = Math.ceil(timeRange / 1440);
    const body = {
      doctorId: userData?.uid,
      startDate: moment().toISOString(),
      endDate: moment().add(dayRange, "day").toISOString(),
    };
    try {
      await updateBooking(booking.bookingId, body);
      props.refashData();
      props.ToggleClose();
    } catch (error) {
      onError(GetErrorMessage(error));
    }
  };
  const pet = props.customer.pets?.find(
    (pet) => pet.pid === props.customer.pid
  );
  return (
    <ModalImplement
      isOpen={props.isOpen}
      hideCloseButton={true}
      onRequestClose={props.ToggleClose}
      size="small"
    >
      <Container>
        <HeaderText>ยืนยันการตอบรับคำขอ</HeaderText>
        <ProfileContainer>
          <ImageProfile
            src={props.customer.imageUrl}
            width={80}
            height={80}
            roundedCircle
          />
          <DescriptionContainer>
            <ProfileName>{props.customer.displayName}</ProfileName>
            <CaseIdText>Case ID: {props.customer.bookingId}</CaseIdText>
            <PetNameContainer>
              ชื่อสัตว์เลี้ยง : <PetSpan>{pet?.petName}</PetSpan>
              &nbsp;&nbsp;ประเภท : <PetSpan>{pet?.petType}</PetSpan>
            </PetNameContainer>
          </DescriptionContainer>
        </ProfileContainer>
        <ButtonContainer>
          <ConfirmButton
            onClick={() => handleDoctorSelectSubmit(props.customer)}
          >
            ยืนยันการตอบรับ
          </ConfirmButton>
          <CancelButton onClick={props.ToggleClose}>ยกเลิก</CancelButton>
        </ButtonContainer>
      </Container>
    </ModalImplement>
  );
};

export default ModalCustomer;
